import { JsonObject } from 'json2typescript';
import CartItem from './CartItem';

@JsonObject('Cart')
export default class Cart {
  constructor() {
    this.cartCode = '';
    this.cartItems = new Array<CartItem>();
  }

  public cartCodeOrg: string;

  public cartCode: string;

  public cartItems: Array<CartItem>;
}
